module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/main-visual_stay-842bde404fee4b246cd82cb47b51600d.webp";